<template>
  <div class="steps-component">
    <ul class="steps is-vertical">
      <li
        class="steps-segment"
        :class="{
          'is-active': step.isActive
        }"
        v-for="(step, key) in steps"
        :key="key"
      >
        <item
          :name="step.name"
          :price="step.price"
          :unit="step.unit"
          :fullWidth="fullWidth"
        ></item>
      </li>
    </ul>
  </div>
</template>

<script>

import Item from "./Item";

export default {

  name: 'steps',

  props: {
    formData: {
      required: true,
      type: Object
    },
    fullWidth: {
      required: false,
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      steps: []
    }
  },

  components: {
    Item
  },

  watch: {
    formData: {
      handler() {
        this.mountSteps()
      },
      deep: true
    }
  },

  computed: {
    partnerType() {
      return this.formData.plan.data.partners.length > 0 ? 'Parceiro' : 'Direto'
    },
    messagePacketName() {
      switch (this.formData.messagePacket.data.mode) {
        case 2:
          return 'Mensagens ilimitadas'
        case 3:
          return 'Atendimentos cloud'
        default:
          return 'Mensagens padrão'
      }
    },
    messagePacketUnit() {
      switch (this.formData.messagePacket.data.mode) {
        case 2:
          return 'mês'
        case 3:
          return 'aten'
        default:
          return 'envio'
      }
    }
  },

  methods: {
    mountSteps() {
      this.steps = []
      for (const [entity, data] of Object.entries(this.formData)) {
        if (data && data.showStep) {
          const objectKeys = Object.keys(this.formData)
          let nextEntity = null;
          for (const [key, entityName] of Object.entries(objectKeys)) {
            if (entityName === entity) {
              const maxCounter = ((Object.entries(objectKeys).length ) - key)
              for (let counter = 1; counter <= maxCounter; counter++) {
                nextEntity = objectKeys[parseInt(key)+counter];
                if ((nextEntity && this.formData[nextEntity].showStep)) {
                  break;
                }
              }
            }
          }

          if (entity === 'messagePacket' && data.data.mode === 3) {
            this.steps.push({
              name: 'Atendimentos recebidos',
              price: data.data.original_price ? data.data.original_price : (data.data.price ? data.data.price : null),
              unit: entity === 'messagePacket' ? this.messagePacketUnit : (data.unit ? data.unit : null),
              isActive: data.data.id && ((nextEntity === undefined) || this.formData[nextEntity].data.id === undefined),
              hasSum: data.hasSum
            })
            this.steps.push({
              name: 'Atendimentos iniciados',
              price: data.data.active_price ? data.data.active_price : null,
              unit: entity === 'messagePacket' ? this.messagePacketUnit : (data.unit ? data.unit : null),
              isActive: data.data.id && ((nextEntity === undefined) || this.formData[nextEntity].data.id === undefined),
              hasSum: data.hasSum
            })
            continue;
          }

          this.steps.push({
            name: entity === 'partner'
                ? this.partnerType
                : (
                    entity === 'messagePacket'
                        ? this.messagePacketName
                        : (
                            data.data.name ? data.data.name : null
                        )
                ),
            price: data.data.original_price ? data.data.original_price : (data.data.price ? data.data.price : null),
            unit: entity === 'messagePacket' ? this.messagePacketUnit : (data.unit ? data.unit : null),
            isActive: data.data.id && ((nextEntity === undefined) || this.formData[nextEntity].data.id === undefined),
            hasSum: data.hasSum
          })
        }
      }
    }
  },

  mounted() {
    this.mountSteps()
  }

}

</script>
